/* prettier-ignore */
import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[scrollControl]',
    exportAs: 'scrollDirective' 
})

export class ScrollCardDirective  {
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkOnResize();
  }

  ngAfterViewInit(){
    let tries = 0;
    const interval = setInterval(() => {
      this.checkOnResize();
      tries++;
      if (tries > 5) clearInterval(interval);
    }, 500);
  }

  @HostListener('click', ['$event.target'])
  scrollElement(item: HTMLElement) {
    const cards = item.closest('.cardsScrollContainer')?.querySelector('.eventContainer');
    if (cards && item.classList?.contains('eventGoLeft'))
        cards.scrollLeft -= window.innerWidth / 2 > 600 ? window.innerWidth / 2 : window.innerWidth - 100;

    if (cards && item.classList?.contains('eventGoRight'))
        cards.scrollLeft += window.innerWidth / 2 > 600 ? window.innerWidth / 2 : window.innerWidth - 100;
  }
  
  @HostListener('scroll', ['$event.target'])
  scrollCardsContainer(item: HTMLElement) {
    const left = item?.closest('.cardsScrollContainer')?.querySelector('.eventGoLeft') as HTMLElement;
    const right = item?.closest('.cardsScrollContainer')?.querySelector('.eventGoRight') as HTMLElement;;
    left.style.opacity = '1';
    left.style.pointerEvents = 'auto'
    right.style.opacity = '1';
    right.style.pointerEvents = 'auto';

    if ((item.scrollLeft + item.clientWidth) >= (item.scrollWidth)) {
      right.style.opacity = '0';
      right.style.pointerEvents = 'none';
    }

    if ((item.scrollLeft) <= 0) {
      left.style.opacity = '0';
      left.style.pointerEvents = 'none';
    }
  }
  
  checkOnResize(){
    const rightArrows = Array.from(document.getElementsByClassName('eventGoRight') as HTMLCollectionOf<HTMLElement>);
    rightArrows?.forEach(arrow => { 
      arrow.style.opacity = "0";
      arrow.style.pointerEvents = 'none';
      const item = arrow.closest('.cardsScrollContainer')?.querySelector('.eventContainer');
      arrow.style.opacity = item && ((item.scrollLeft + item.clientWidth) >= (item.scrollWidth)) ? "0" : "1";
      arrow.style.pointerEvents = item && ((item.scrollLeft + item.clientWidth) >= (item.scrollWidth)) ? "none" : "all";
    });
    const leftArrows = Array.from(document.getElementsByClassName('eventGoLeft') as HTMLCollectionOf<HTMLElement>);
    leftArrows?.forEach(arrow => {
      arrow.style.opacity = "0";
      arrow.style.pointerEvents = 'none';
      const item = arrow.closest('.cardsScrollContainer')?.querySelector('.eventContainer');
      arrow.style.opacity = item && ((item.scrollLeft) <= 0) ? "0" : "1";
      arrow.style.pointerEvents = item && ((item.scrollLeft) <= 0) ? "none" : "all";
    });
  }

}